/***
 * 客户资产分析
 */
import { post, get, postJson, put } from '../axios'
const RESOURCE_BASE_PATH = '/customer-asset-analysis'

// 客户资产总览
export const overView = p => get(`${RESOURCE_BASE_PATH}/overView`, p);

// 客户资产结构
export const construction = p => get(`${RESOURCE_BASE_PATH}/construction`, p);

// 入会趋势分析
export const trends = p => get(`${RESOURCE_BASE_PATH}/trends`, p);

// 导出数据
export const exportData = p => get(`${RESOURCE_BASE_PATH}/export`, p);

// 导出数据
export const exportDataOne = p => get(`/customer-asset-analysis/export`,p);

